// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".records[data-v-6819c672]{display:flex;align-items:center;font-size:15px;color:#4b5068}.record-num[data-v-6819c672]{padding:0 5px}", ""]);
// Exports
module.exports = exports;
